import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import baseUrl from '../slices/baseUrl';

// Create an async thunk to fetch notifications by clientId

export const getNotificationByEmail = createAsyncThunk(
    'data/getNotificationByEmail',
    async email => {
        const response = await axios.get(`${baseUrl}/notifications/getNotifi/${email}`);
        return response.data;
    }
);

export const getNotificationCountByEmailId = createAsyncThunk(
    'data/getNotificationCountByEmailId',
    async email => {
        const response = await axios.get(
            `${baseUrl}/notifications/unseen/${email}`
        );
        return response.data;
    }
);

export const clearAllNotificationsByUserId = createAsyncThunk(
    'clear/clearAllNotificationsByUserId',
    async userId => {
        const response = await axios.delete(
            `${baseUrl}/notifications/clearNotification/${userId}`
        );
        return response.data;
    }
);

export const clearAllNotifications = createAsyncThunk(
    'clear/clearAllNotifications',
    async email => {
        const response = await axios.delete(
            `${baseUrl}/notifications/clearAllByEmail/${email}`
        );
        return response.data;
    }
);

export const deleteNotificationById = createAsyncThunk(
    'data/deleteNotificationById',
    async noteId => {
        const response = await axios.delete(
            `${baseUrl}/notifications/deleteNotificationById/${noteId}`
        );
        return response.data;
    }
);

const initialState = {
    notifications: [],
    notificationCount: 0,
    status: 'idle',
    error: null,
    isNotificationDeleted: false
};

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {},
    extraReducers: builder => {
        // Handle the pending and fulfilled actions for the async thunk

        builder
            .addCase(getNotificationByEmail.pending, state => {
                state.status = 'loading';
            })
            .addCase(getNotificationByEmail.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action?.payload?.length === 0) {
                    state.notifications = [];
                } else {
                    state.notifications = action.payload;
                }
            })
            .addCase(getNotificationByEmail.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });

        builder
            .addCase(getNotificationCountByEmailId.pending, state => {
                state.status = 'loading';
            })
            .addCase(
                getNotificationCountByEmailId.fulfilled,
                (state, action) => {
                    state.status = 'succeeded';
                    state.notificationCount = action.payload;
                }
            )
            .addCase(
                getNotificationCountByEmailId.rejected,
                (state, action) => {
                    state.status = 'failed';
                    state.error = action.error.message;
                }
            );
        builder
            .addCase(clearAllNotificationsByUserId.pending, state => {
                state.status = 'loading';
            })
            .addCase(clearAllNotificationsByUserId.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.notifications = [];
                state.notificationCount = 0;
            })
            .addCase(clearAllNotificationsByUserId.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });

        builder
            .addCase(clearAllNotifications.pending, state => {
                state.status = 'loading';
            })
            .addCase(clearAllNotifications.fulfilled, (state, action) => {
                state.status = 'succeeded';

                state.notifications = [];
                state.notificationCount = 0;
            })
            .addCase(clearAllNotifications.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });

        builder
            .addCase(deleteNotificationById.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteNotificationById.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.isNotificationDeleted = true;
                const deletedNotificationId = action.payload;
                state.notifications = state.notifications.filter(
                    notification => notification.id !== deletedNotificationId
                );
            })
            .addCase(deleteNotificationById.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    }
});

// Export the reducer
export default notificationSlice.reducer;
